import React from "react";
import Toggler from "./toggler/Toggler";
import appstyles from "./styles/app.module.css"
import VideoPoster from "./toggler/VideoPoster";
import VideoPlayer from "./toggler/VideoPlayer";
function App() {

 const [togglerStatus, setTogglerStatus] = React.useState("female")
 const [isModal, setIsModal] = React.useState(false);
 const [videoToPlay, setVideotoPlay] = React.useState({videoid:0, videopath:"/f/"});


  return (
    <div className="App">

        <section className={appstyles.videomasterframe}>

    <Toggler tooglerStatus={togglerStatus} setTooglerStatus = {setTogglerStatus} togHeadline = "Redner"/>

 <section className={appstyles.videposterframe}>

    <VideoPoster togglerStatus = {togglerStatus} setVideoToPlay = {setVideotoPlay} setIsModal = {setIsModal} videoToPlay ={videoToPlay}/>

 </section>
            {
                isModal

                ? (
<VideoPlayer videotoPLay = {videoToPlay} setIsModal = {setIsModal}/>
                    ):("")

                    }


        </section>

        </div>
  );
}

export default App;
